// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__v5ORp","modal":"modal_modal__Y0lMT","close":"modal_close__ExN8g"};